import { ArrowUpRight, Sparkles, Cpu, Heart } from "lucide-react";
import { HERO_IMAGE, buildWhatsAppLink } from "@/data/lakaData";
import LakaLogo from "./LakaLogo";

const trustBadges = [
  { icon: Heart, label: "Diagnóstico personalizado" },
  { icon: Cpu, label: "Tecnología beauty avanzada" },
  { icon: Sparkles, label: "Resultados visibles y naturales" },
];

const Hero = () => {
  const goTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      id="inicio"
      data-testid="hero-section"
      className="relative pt-32 pb-20 md:pt-40 md:pb-28 overflow-hidden"
      style={{ background: "#FBF6F2" }}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Left - Text */}
          <div className="lg:col-span-6 laka-fade-up">
            <div className="flex items-center mb-8">
              <span className="laka-eyebrow">Estética avanzada & Bienestar</span>
            </div>
            <h1 className="font-serif-laka text-[2.6rem] sm:text-5xl lg:text-6xl xl:text-[4.2rem] leading-[1.04] text-[#1A1A1A] font-light">
              Estética avanzada
              <br />
              <span className="italic text-[#1A1A1A]/90">para verte bien</span>
              <br />
              <span className="text-[#D6B36A]">y sentirte mejor.</span>
            </h1>
            <p className="mt-8 text-[0.95rem] md:text-base leading-relaxed text-[#1A1A1A]/70 max-w-xl font-light">
              Tratamientos faciales, corporales y tecnología beauty en un
              espacio elegante, cercano y personalizado en Andújar.
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <button
                data-testid="hero-book-btn"
                onClick={() => goTo("contacto")}
                className="laka-btn-primary"
              >
                Pedir cita
                <ArrowUpRight className="w-4 h-4" strokeWidth={1.5} />
              </button>
              <button
                data-testid="hero-treatments-btn"
                onClick={() => goTo("tratamientos")}
                className="laka-btn-ghost"
              >
                Ver tratamientos
              </button>
            </div>

            <div className="mt-14 grid sm:grid-cols-3 gap-6 max-w-2xl">
              {trustBadges.map(({ icon: Icon, label }, i) => (
                <div
                  key={label}
                  data-testid={`hero-trust-badge-${i}`}
                  className="flex items-start gap-3"
                >
                  <span className="mt-1 inline-flex items-center justify-center w-8 h-8 border border-[#D6B36A]/60 rounded-full">
                    <Icon className="w-4 h-4 text-[#D6B36A]" strokeWidth={1.4} />
                  </span>
                  <span className="text-[0.78rem] leading-snug text-[#1A1A1A]/80 font-medium">
                    {label}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Right - Image */}
          <div className="lg:col-span-6 relative">
            <div className="relative">
              <div
                className="absolute -top-6 -left-6 hidden md:block w-32 h-32 border border-[#D6B36A]/60"
                aria-hidden="true"
              />
              <div
                className="absolute -bottom-6 -right-6 hidden md:block w-32 h-32 bg-[#E8DFD1]"
                aria-hidden="true"
              />
              <div className="relative overflow-hidden">
                <img
                  data-testid="hero-image"
                  src={HERO_IMAGE}
                  alt="Piel luminosa y cuidada"
                  className="w-full h-[420px] sm:h-[520px] lg:h-[640px] object-cover"
                  loading="eager"
                />
              </div>
              <div className="absolute bottom-6 left-6 md:bottom-8 md:left-8 bg-[#FBF6F2]/95 backdrop-blur px-6 py-4 border-l-2 border-[#D6B36A] flex items-center gap-4">
                <LakaLogo className="h-10 md:h-12" variant="dark" />
                <div className="pl-4 border-l border-[#1A1A1A]/10">
                  <div className="text-[0.6rem] tracking-[0.3em] uppercase text-[#D6B36A]">
                    Boutique beauty
                  </div>
                  <div className="font-serif-laka text-lg text-[#1A1A1A] mt-0.5">
                    Andújar · Jaén
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
